<div data-toggle="tooltip" title="[{{ room?.id }}] {{ room?.description | striphtml }}" class="room-box">
	<div class="room-row roomNumber">
		{{ room?.roomNumber }}
		<br />
		<small>
			<!-- <i class="fas fa-info-circle"></i> -->
			p. {{ room?.level }}
		</small>
	</div>
	<div class="room-row roomView">
		{{ room?.view }}<br />
		<small>{{ room?.roomType?.code }}</small>
	</div>
	<div class="room-row roomOccupancy">
		<small>{{ room?.occupancy }}</small>
	</div>
	<div class="roomConveniences">
		<span *ngFor="let convenient of room?.conveniences"> {{ convenient.name }}, </span>
	</div>
</div>
